import _jsx from "@babel/runtime/helpers/jsx";
import clsx from 'clsx';
import keycode from 'keycode';
import React from 'react';
import PropTypes from 'prop-types';
import RootCloseWrapper from 'react-overlays/lib/RootCloseWrapper';
import { bsClass, getClassSet, prefix, splitBsPropsAndOmit } from './utils/bootstrapUtils';
import createChainedFunction from './utils/createChainedFunction';
import ValidComponentChildren from './utils/ValidComponentChildren';
class DropdownMenu extends React.Component {
  constructor(props) {
    super(props);
    this.handleRootClose = this.handleRootClose.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.menuRef = /*#__PURE__*/React.createRef(); // Create a ref for the menu
  }
  handleKeyDown(event) {
    switch (event.keyCode) {
      case keycode.codes.down:
        this.focusNext();
        event.preventDefault();
        break;
      case keycode.codes.up:
        this.focusPrevious();
        event.preventDefault();
        break;
      case keycode.codes.esc:
      case keycode.codes.tab:
        this.props.onClose(event, {
          source: 'keydown'
        });
        break;
      default:
    }
  }
  handleRootClose(event) {
    this.props.onClose(event, {
      source: 'rootClose'
    });
  }
  getFocusableMenuItems() {
    const node = this.menuRef.current; // Use ref instead of findDOMNode
    if (!node) {
      return [];
    }
    return Array.from(node.querySelectorAll('[tabIndex="-1"]'));
  }
  getItemsAndActiveIndex() {
    const items = this.getFocusableMenuItems();
    const activeIndex = items.indexOf(document.activeElement);
    return {
      items,
      activeIndex
    };
  }
  focusNext() {
    const {
      items,
      activeIndex
    } = this.getItemsAndActiveIndex();
    if (items.length === 0) {
      return;
    }
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    items[nextIndex].focus();
  }
  focusPrevious() {
    const {
      items,
      activeIndex
    } = this.getItemsAndActiveIndex();
    if (items.length === 0) {
      return;
    }
    const prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    items[prevIndex].focus();
  }
  render() {
    const {
      open,
      pullRight,
      labelledBy,
      onSelect,
      className,
      rootCloseEvent,
      children,
      ...props
    } = this.props;
    const [bsProps, elementProps] = splitBsPropsAndOmit(props, ['onClose']);
    const classes = {
      ...getClassSet(bsProps),
      [prefix(bsProps, 'right')]: pullRight
    };
    return /*#__PURE__*/_jsx(RootCloseWrapper, {
      disabled: !open,
      onRootClose: this.handleRootClose,
      event: rootCloseEvent
    }, void 0, /*#__PURE__*/React.createElement("ul", Object.assign({}, elementProps, {
      role: "menu",
      className: clsx(className, classes),
      "aria-labelledby": labelledBy,
      ref: this.menuRef // Attach the ref to the <ul> element
    }), ValidComponentChildren.map(children, child => /*#__PURE__*/React.cloneElement(child, {
      onKeyDown: createChainedFunction(child.props.onKeyDown, this.handleKeyDown),
      onSelect: createChainedFunction(child.props.onSelect, onSelect)
    }))));
  }
}
DropdownMenu.defaultProps = {
  bsRole: 'menu',
  pullRight: false
};
export default bsClass('dropdown-menu', DropdownMenu);